import * as React from 'react';

import { theme } from '@lightspeed/flame/Core/themes/flame';
import { Divider } from '@lightspeed/flame/Divider';
import { Text } from '@lightspeed/flame/Text';

import { BarcodeEntity, BarcodeSyncStatus } from 'root/apps/InventoryCountScanQueue/BarcodeService';

import { LabelRow } from './ScanQueueListLabel';
import { ScanRow } from './ScanQueueListRow';
import { TitleRow } from './ScanQueueListTitle';

interface ScanListProps {
  title: string;
  status: BarcodeSyncStatus;
  count: number;
  scanCollection: BarcodeEntity[];
  emptyStateMsg?: string;
}

export const ScanListing: React.FC<ScanListProps> = ({
  title,
  status,
  count,
  scanCollection,
  emptyStateMsg,
}) => {
  const { lang } = window.merchantos.locale;

  const dateFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  } as Intl.DateTimeFormatOptions;

  return (
    <>
      <TitleRow title={title} status={status} count={count} />
      <Divider color={theme.colors['gray-100']} />
      <LabelRow status={status} />
      <Divider color={theme.colors['gray-100']} />
      {scanCollection.length > 0 ? (
        scanCollection.map((scan) => (
          <div key={scan.id}>
            <ScanRow
              barcode={scan.barcode}
              time={new Date(scan.updatedAt).toLocaleTimeString(lang, dateFormatOptions)}
              status={scan.status}
              description={scan.description}
              id={scan.id}
            />
            <Divider color={theme.colors['gray-100']} />
          </div>
        ))
      ) : (
        <>
          <Text py={2} textAlign="center" fontWeight="bold">
            {emptyStateMsg}
          </Text>
          <Divider color={theme.colors['gray-100']} />
        </>
      )}
    </>
  );
};
